<template>
  <div class="filter_indicator">
    <div class="indicator_wrap">
      <div class="indicator_colour">
        <div :class="getCss(1)" @click="selectValue(1)" :style="value > 1 ? 'cursor: pointer;' : ''">
          <span>1</span>
        </div>
      </div>
      <div class="indicator_colour">
        <div :class="getCss(2)" @click="selectValue(2)" :style="value > 2 ? 'cursor: pointer;' : ''">
          <span>2</span>
        </div>
      </div>
      <div class="indicator_colour">
        <div :class="getCss(3)" @click="selectValue(3)">
          <span>3</span>
        </div>
      </div>
    </div>
    <div class="thin_line"></div>
  </div>
</template>

<script>
export default {
    data: function () {
      return {
       // value: 1
      };
    },
    props: ['value'],
    methods: {
      getCss(step) {
        if(this.value == step ) {
          return "indicator_number";
        } else {
          return "indicator_number grey";
        }
      },
      selectValue(val) {
        if(val < this.value) {
          this.value = val;
          this.$emit('input', val)
        }
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/SubComponents/FormIndicator.vue